var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoundWaves(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 203,
    viewBox: "0 0 375 203",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "52.184%",
    y1: "100%",
    x2: "52.184%",
    y2: "0%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39A4A1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C60D9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "52.184%",
    y1: "100%",
    x2: "52.184%",
    y2: "0%",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39A4A1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C60D9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "52.184%",
    y1: "100%",
    x2: "52.184%",
    y2: "0%",
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39A4A1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C60D9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "52.184%",
    y1: "100%",
    x2: "52.184%",
    y2: "0%",
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39A4A1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C60D9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "52.184%",
    y1: "100%",
    x2: "52.184%",
    y2: "0%",
    id: "e"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39A4A1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C60D9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "52.184%",
    y1: "100%",
    x2: "52.184%",
    y2: "0%",
    id: "f"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39A4A1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C60D9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "52.184%",
    y1: "100%",
    x2: "52.184%",
    y2: "0%",
    id: "g"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39A4A1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C60D9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "52.184%",
    y1: "100%",
    x2: "52.184%",
    y2: "0%",
    id: "h"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39A4A1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C60D9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "52.184%",
    y1: "100%",
    x2: "52.184%",
    y2: "0%",
    id: "i"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39A4A1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C60D9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "52.184%",
    y1: "100%",
    x2: "52.184%",
    y2: "0%",
    id: "j"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39A4A1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C60D9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "52.184%",
    y1: "100%",
    x2: "52.184%",
    y2: "0%",
    id: "k"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39A4A1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C60D9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "52.184%",
    y1: "100%",
    x2: "52.184%",
    y2: "0%",
    id: "l"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39A4A1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C60D9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "52.184%",
    y1: "100%",
    x2: "52.184%",
    y2: "0%",
    id: "m"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39A4A1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C60D9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "52.184%",
    y1: "100%",
    x2: "52.184%",
    y2: "0%",
    id: "n"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39A4A1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C60D9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "52.184%",
    y1: "100%",
    x2: "52.184%",
    y2: "0%",
    id: "o"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39A4A1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C60D9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "52.184%",
    y1: "100%",
    x2: "52.184%",
    y2: "0%",
    id: "p"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39A4A1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C60D9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "52.184%",
    y1: "100%",
    x2: "52.184%",
    y2: "0%",
    id: "q"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39A4A1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C60D9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "52.184%",
    y1: "100%",
    x2: "52.184%",
    y2: "0%",
    id: "r"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39A4A1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C60D9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "52.184%",
    y1: "100%",
    x2: "52.184%",
    y2: "0%",
    id: "s"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39A4A1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C60D9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "52.184%",
    y1: "100%",
    x2: "52.184%",
    y2: "0%",
    id: "t"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39A4A1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C60D9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "52.184%",
    y1: "100%",
    x2: "52.184%",
    y2: "0%",
    id: "u"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39A4A1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C60D9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "52.184%",
    y1: "100%",
    x2: "52.184%",
    y2: "0%",
    id: "v"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39A4A1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C60D9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "52.184%",
    y1: "100%",
    x2: "52.184%",
    y2: "0%",
    id: "w"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39A4A1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C60D9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "52.184%",
    y1: "100%",
    x2: "52.184%",
    y2: "0%",
    id: "x"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39A4A1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C60D9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "52.184%",
    y1: "100%",
    x2: "52.184%",
    y2: "0%",
    id: "y"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39A4A1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C60D9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "52.184%",
    y1: "100%",
    x2: "52.184%",
    y2: "0%",
    id: "z"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39A4A1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C60D9",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.904 149h-1.809c-1.157 0-2.095-.962-2.095-2.147V81.146c0-1.185.938-2.146 2.095-2.146h1.809C41.06 79 42 79.96 42 81.146v65.707c0 1.185-.939 2.147-2.096 2.147",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.187 117h-2.373C9.813 117 9 116.16 9 115.122V81.17c0-1.198.939-2.17 2.096-2.17h1.809c1.157 0 2.095.972 2.095 2.17v33.952c0 1.037-.812 1.878-1.813 1.878",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.186 130h-2.372c-1.002 0-1.814-.826-1.814-1.845V80.132c0-1.178.938-2.132 2.096-2.132h1.808c1.158 0 2.096.954 2.096 2.132v48.023c0 1.019-.811 1.845-1.814 1.845",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.904 106H2.095A2.095 2.095 0 0 1 0 103.906V91.093C0 89.937.938 89 2.095 89h1.809C5.062 89 6 89.937 6 91.093v12.813A2.095 2.095 0 0 1 3.904 106",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.187 113h-2.373c-1.002 0-1.814-.831-1.814-1.856V48.146C27 46.96 27.939 46 29.096 46h1.809c1.157 0 2.095.961 2.095 2.146v62.998c0 1.025-.812 1.856-1.813 1.856",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.187 155h-2.373c-1.002 0-1.814-.844-1.814-1.883v-33.941c0-1.202.939-2.176 2.096-2.176h1.809c1.157 0 2.095.974 2.095 2.176v33.941c0 1.04-.812 1.883-1.813 1.883",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.904 123h-1.808c-1.158 0-2.096-.95-2.096-2.123V87.123C45 85.95 45.938 85 47.096 85h1.808c1.158 0 2.096.95 2.096 2.123v33.754c0 1.173-.938 2.123-2.096 2.123",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.904 103h-1.81c-1.156 0-2.094-.96-2.094-2.145v-56.71c0-1.184.938-2.145 2.095-2.145h1.81c1.157 0 2.095.961 2.095 2.146v56.71c0 1.184-.938 2.144-2.096 2.144",
    fill: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.904 38h-1.81c-1.156 0-2.094-.96-2.094-2.145v-10.71c0-1.185.938-2.145 2.095-2.145h1.81c1.157 0 2.095.96 2.095 2.145v10.71c0 1.185-.938 2.145-2.096 2.145",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.904 185h-1.81c-1.156 0-2.094-.966-2.094-2.156v-73.689c0-1.19.938-2.155 2.095-2.155h1.81c1.157 0 2.095.965 2.095 2.155v73.69c0 1.19-.938 2.155-2.096 2.155",
    fill: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.904 148h-1.809c-1.157 0-2.095-.965-2.095-2.155v-84.69c0-1.19.938-2.155 2.095-2.155h1.809c1.157 0 2.096.964 2.096 2.154v84.69c0 1.19-.939 2.156-2.096 2.156",
    fill: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.904 75h-1.808c-1.158 0-2.096-.958-2.096-2.14V35.14c0-1.182.938-2.14 2.096-2.14h1.808c1.158 0 2.096.958 2.096 2.14v37.72c0 1.182-.938 2.14-2.096 2.14",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.904 194h-1.808c-1.158 0-2.096-.958-2.096-2.14V80.14c0-1.182.938-2.139 2.096-2.139h1.808c1.158 0 2.096.957 2.096 2.139V191.86c0 1.182-.938 2.14-2.096 2.14",
    fill: "url(#i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.096 178h1.808c1.158 0 2.096-.958 2.096-2.14V2.14C105 .958 104.062 0 102.904 0h-1.808C99.938 0 99 .958 99 2.141V175.86c0 1.182.938 2.14 2.096 2.14",
    fill: "url(#j)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.096 193h1.808c1.158 0 2.096-.96 2.096-2.145V16.144C78 14.96 77.062 14 75.904 14h-1.808C72.938 14 72 14.96 72 16.144v174.711c0 1.184.938 2.145 2.096 2.145",
    fill: "url(#k)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.095 127h1.809c1.158 0 2.096-.968 2.096-2.163V38.163C87 36.968 86.062 36 84.904 36h-1.809C81.94 36 81 36.968 81 38.163v86.674c0 1.195.939 2.163 2.095 2.163",
    fill: "url(#l)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.095 175h1.809c1.158 0 2.096-.958 2.096-2.142v-39.717c0-1.183-.938-2.141-2.096-2.141h-1.809c-1.156 0-2.095.958-2.095 2.141v39.717c0 1.184.939 2.142 2.095 2.142",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.096 191h1.809c1.157 0 2.095-.963 2.095-2.15V65.15c0-1.187-.938-2.15-2.095-2.15h-1.809C90.94 63 90 63.963 90 65.15v123.7c0 1.187.939 2.15 2.096 2.15",
    fill: "url(#m)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.096 59h1.809C95.062 59 96 58.014 96 56.798V29.203C96 27.986 95.062 27 93.905 27h-1.809C90.938 27 90 27.986 90 29.203v27.595c0 1.216.938 2.202 2.096 2.202m0-36h1.809C95.062 23 96 22.005 96 20.778V10.222C96 8.995 95.062 8 93.905 8h-1.809C90.938 8 90 8.995 90 10.222v10.556c0 1.227.938 2.222 2.096 2.222",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.096 156h1.809c1.157 0 2.095-.965 2.095-2.157V52.156c0-1.19-.938-2.156-2.095-2.156h-1.809C63.938 50 63 50.965 63 52.156v101.687c0 1.192.938 2.157 2.096 2.157",
    fill: "url(#n)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.096 167h1.809c1.157 0 2.095-.969 2.095-2.162V43.162c0-1.194-.938-2.162-2.095-2.162h-1.809c-1.157 0-2.096.968-2.096 2.162v121.676c0 1.193.939 2.162 2.096 2.162",
    fill: "url(#o)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.904 135h-1.809c-1.157 0-2.095-.964-2.095-2.153V74.152c0-1.188.938-2.152 2.095-2.152h1.809C59.06 72 60 72.964 60 74.152v58.695c0 1.19-.939 2.153-2.096 2.153",
    fill: "url(#p)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.905 130h-1.809c-1.157 0-2.096-.962-2.096-2.148V79.148c0-1.187.939-2.149 2.096-2.149h1.809c1.157 0 2.095.962 2.095 2.149v48.703c0 1.186-.938 2.148-2.095 2.148",
    fill: "url(#q)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.904 145h-1.808c-1.158 0-2.096-.966-2.096-2.159V63.16c0-1.193.938-2.159 2.096-2.159h1.808c1.158 0 2.096.966 2.096 2.159v79.682c0 1.193-.938 2.159-2.096 2.159",
    fill: "url(#r)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.904 103h-1.81c-1.156 0-2.094-.96-2.094-2.145v-56.71c0-1.184.938-2.145 2.095-2.145h1.81c1.157 0 2.095.961 2.095 2.146v56.71c0 1.184-.938 2.144-2.096 2.144",
    fill: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.904 38h-1.81c-1.156 0-2.094-.96-2.094-2.145v-10.71c0-1.185.938-2.145 2.095-2.145h1.81c1.157 0 2.095.96 2.095 2.145v10.71c0 1.185-.938 2.145-2.096 2.145",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.904 185h-1.81c-1.156 0-2.094-.966-2.094-2.156v-73.689c0-1.19.938-2.155 2.095-2.155h1.81c1.157 0 2.095.965 2.095 2.155v73.69c0 1.19-.938 2.155-2.096 2.155",
    fill: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.904 148h-1.809c-1.157 0-2.095-.965-2.095-2.155v-84.69c0-1.19.938-2.155 2.095-2.155h1.809c1.157 0 2.096.964 2.096 2.154v84.69c0 1.19-.939 2.156-2.096 2.156",
    fill: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.99 74h-1.808c-1.158 0-2.096-.958-2.096-2.14V34.14c0-1.182.938-2.14 2.096-2.14h1.808c1.158 0 2.096.958 2.096 2.14v37.72c0 1.182-.938 2.14-2.096 2.14",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.904 194h-1.808c-1.158 0-2.096-.958-2.096-2.14V80.14c0-1.182.938-2.139 2.096-2.139h1.808c1.158 0 2.096.957 2.096 2.139V191.86c0 1.182-.938 2.14-2.096 2.14",
    fill: "url(#i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.096 178h1.808c1.158 0 2.096-.958 2.096-2.14V2.14C330 .958 329.062 0 327.904 0h-1.808C324.938 0 324 .958 324 2.141V175.86c0 1.182.938 2.14 2.096 2.14",
    fill: "url(#j)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.096 193h1.808c1.158 0 2.096-.96 2.096-2.145V16.144c0-1.184-.938-2.144-2.096-2.144h-1.808c-1.158 0-2.096.96-2.096 2.144v174.711c0 1.184.938 2.145 2.096 2.145",
    fill: "url(#k)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.095 127h1.809c1.158 0 2.096-.968 2.096-2.163V38.163c0-1.195-.938-2.163-2.096-2.163h-1.809c-1.156 0-2.095.968-2.095 2.163v86.674c0 1.195.939 2.163 2.095 2.163",
    fill: "url(#l)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.095 175h1.809c1.158 0 2.096-.958 2.096-2.142v-39.717c0-1.183-.938-2.141-2.096-2.141h-1.809c-1.156 0-2.095.958-2.095 2.141v39.717c0 1.184.939 2.142 2.095 2.142",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.096 193h1.809c1.157 0 2.095-.963 2.095-2.15V67.15c0-1.187-.938-2.15-2.095-2.15h-1.809c-1.157 0-2.096.963-2.096 2.15v123.7c0 1.187.939 2.15 2.096 2.15",
    fill: "url(#m)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.096 61h1.809c1.157 0 2.095-.986 2.095-2.202V31.203c0-1.217-.938-2.203-2.095-2.203h-1.809c-1.158 0-2.096.986-2.096 2.203v27.595c0 1.216.938 2.202 2.096 2.202m0-36h1.809c1.157 0 2.095-.995 2.095-2.222V12.222c0-1.227-.938-2.222-2.095-2.222h-1.809c-1.158 0-2.096.995-2.096 2.222v10.556c0 1.227.938 2.222 2.096 2.222",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.096 156h1.809c1.157 0 2.095-.965 2.095-2.157V52.156c0-1.19-.938-2.156-2.095-2.156h-1.809c-1.158 0-2.096.965-2.096 2.156v101.687c0 1.192.938 2.157 2.096 2.157",
    fill: "url(#n)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.096 167h1.809c1.157 0 2.095-.969 2.095-2.162V43.162c0-1.194-.938-2.162-2.095-2.162h-1.809c-1.157 0-2.096.968-2.096 2.162v121.676c0 1.193.939 2.162 2.096 2.162",
    fill: "url(#o)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.904 135h-1.809c-1.157 0-2.095-.964-2.095-2.153V74.152c0-1.188.938-2.152 2.095-2.152h1.809c1.157 0 2.096.964 2.096 2.152v58.695c0 1.19-.939 2.153-2.096 2.153",
    fill: "url(#p)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.905 130h-1.809c-1.157 0-2.096-.962-2.096-2.148V79.148c0-1.187.939-2.149 2.096-2.149h1.809c1.157 0 2.095.962 2.095 2.149v48.703c0 1.186-.938 2.148-2.095 2.148",
    fill: "url(#q)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.904 145h-1.808c-1.158 0-2.096-.966-2.096-2.159V63.16c0-1.193.938-2.159 2.096-2.159h1.808c1.158 0 2.096.966 2.096 2.159v79.682c0 1.193-.938 2.159-2.096 2.159m-108 30h-1.808c-1.158 0-2.096-.966-2.096-2.159V93.16c0-1.193.938-2.159 2.096-2.159h1.808c1.158 0 2.096.966 2.096 2.159v79.682c0 1.193-.938 2.159-2.096 2.159",
    fill: "url(#r)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.905 164h-1.809c-1.158 0-2.096-.96-2.096-2.145v-58.71c0-1.184.938-2.145 2.096-2.145h1.809c1.156 0 2.095.96 2.095 2.145v58.71c0 1.184-.939 2.145-2.095 2.145",
    fill: "url(#p)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.904 185h-1.809c-1.157 0-2.095-.963-2.095-2.152V26.152c0-1.189.938-2.152 2.095-2.152h1.809c1.157 0 2.096.963 2.096 2.152v156.696c0 1.189-.939 2.152-2.096 2.152",
    fill: "url(#s)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.904 127h-1.808c-1.158 0-2.096-.964-2.096-2.154V50.155c0-1.19.938-2.155 2.096-2.155h1.808c1.158 0 2.096.964 2.096 2.155v74.691c0 1.19-.938 2.154-2.096 2.154",
    fill: "url(#t)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.904 159h-1.808c-1.158 0-2.096-.963-2.096-2.15v-24.702c0-1.186.938-2.148 2.096-2.148h1.808c1.158 0 2.096.962 2.096 2.148v24.703c0 1.186-.938 2.149-2.096 2.149m-18-71h-1.808c-1.157 0-2.096-.963-2.096-2.15v-14.7c0-1.187.939-2.15 2.096-2.15h1.809c1.157 0 2.095.963 2.095 2.15v14.7c0 1.187-.938 2.15-2.095 2.15",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.905 203h-1.809c-1.157 0-2.096-.964-2.096-2.154V94.156c0-1.192.939-2.156 2.096-2.156h1.809c1.157 0 2.095.964 2.095 2.155v106.69c0 1.19-.938 2.155-2.095 2.155",
    fill: "url(#u)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.904 176h-1.808c-1.158 0-2.096-.961-2.096-2.147V92.147c0-1.186.938-2.147 2.096-2.147h1.808c1.158 0 2.096.961 2.096 2.147v81.706c0 1.186-.938 2.147-2.096 2.147",
    fill: "url(#v)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.904 136h-1.809c-1.157 0-2.095-.972-2.095-2.17V85.17c0-1.198.938-2.169 2.095-2.169h1.809c1.158 0 2.096.97 2.096 2.169v48.661c0 1.198-.938 2.17-2.096 2.17",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.904 194h-1.809c-1.157 0-2.095-.962-2.095-2.148v-50.704c0-1.186.938-2.148 2.095-2.148h1.809c1.158 0 2.096.962 2.096 2.148v50.704c0 1.186-.938 2.148-2.096 2.148",
    fill: "url(#w)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.905 164h-1.809c-1.157 0-2.096-.962-2.096-2.15v-57.7c0-1.188.939-2.15 2.096-2.15h1.809c1.157 0 2.095.962 2.095 2.15v57.7c0 1.188-.938 2.15-2.095 2.15",
    fill: "url(#x)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.905 107h-1.809c-1.158 0-2.096-.972-2.096-2.171V74.17c0-1.199.938-2.171 2.096-2.171h1.809c1.157 0 2.095.972 2.095 2.171v30.658c0 1.199-.938 2.171-2.095 2.171",
    fill: "url(#y)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.905 126h-1.809a2.103 2.103 0 0 1-2.096-2.11v-12.78c0-1.166.938-2.11 2.096-2.11h1.809c1.157 0 2.095.944 2.095 2.11v12.78c0 1.165-.938 2.11-2.095 2.11m18-21h-1.809a2.095 2.095 0 0 1-2.096-2.094V90.094c0-1.157.938-2.094 2.096-2.094h1.809c1.157 0 2.095.937 2.095 2.094v12.812a2.095 2.095 0 0 1-2.095 2.094",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.904 163h-1.809c-1.157 0-2.095-.962-2.095-2.15v-67.7c0-1.188.938-2.15 2.095-2.15h1.809c1.157 0 2.096.962 2.096 2.15v67.7c0 1.188-.939 2.15-2.096 2.15",
    fill: "url(#z)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.904 115h-1.808c-1.158 0-2.096-.984-2.096-2.197V79.197c0-1.213.938-2.197 2.096-2.197h1.808c1.158 0 2.096.984 2.096 2.197v33.606c0 1.213-.938 2.197-2.096 2.197",
    fill: "url(#b)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundWaves);
export default __webpack_public_path__ + "static/media/SoundWaves.ff432ed7.svg";
export { ForwardRef as ReactComponent };